import { StackingProgress } from './StackingProgress';

export default StackingProgress;
